import { format } from 'date-fns'
import { ja } from 'date-fns/locale'

const WEEKDAY_LABELS = {
    ja: ['月', '火', '水', '木', '金', '土', '日'],
    en: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
}

export const formatShiftDayLabel = (day, dayIndex, lang) => {
    const weekday = (lang === 'en' ? WEEKDAY_LABELS.en : WEEKDAY_LABELS.ja)[dayIndex]
    const dateStr =
        lang === 'en' ? format(day, 'M/d') : format(day, 'M/d', { locale: ja })
    return `${dateStr} (${weekday})`
}
